module.exports = __webpack_public_path__ + "img/fram3.030b6a20.png";